import { getStudioGameStore } from '@op/services';
import { arrayToObj, arrayToSimpleObj } from '@op/utils';
import { useEffect, useMemo, useState } from 'react';
import { dealwithPcConsoleTimeline } from '../utils';

type SteamItemType = { review: number; score: number };
export const getDefaultReview = () => ({ review: 0, score: 0 });
const channelMapItem: any = {
  xbox: 'lifetime',
  playstation: 'lifetime',
  metacritic: 'meta_score',
  opencritic: 'top_critic_average',
};

function dealwithOpencritic(
  list = [],
  channel: string,
  renderKey: string = 'top_critic_average',
) {
  const item = list.find((it: any) => it.key === renderKey);
  return {
    channel,
    review: 0,
    score: 0,
    ...(item || {}),
  };
}

export function useGameStorePcConsole({ filter }: any) {
  const [steamInfo, setSteamInfo] = useState<{
    all_reviews: SteamItemType;
    recent_reviews: SteamItemType;
  }>({
    all_reviews: getDefaultReview(),
    recent_reviews: getDefaultReview(),
  });

  const [trendTimeline, setTrendsTimeline] = useState({
    list: [],
    timeline_of_end_time: '',
    timeline_of_start_time: '',
  });

  const [bottomGameStore, setBottomGameStore] = useState<any>({});
  const [loading, setLoading] = useState(false);

  function requestServerData() {
    setLoading(true);
    getStudioGameStore(filter)
      .then((data: any) => {
        const { list, timeline_of_end_time, timeline_of_start_time, timeline } =
          data || {};
        const gameStoreMap = arrayToSimpleObj(list, 'list', 'channel');
        const localTrendsTimeline: any = dealwithPcConsoleTimeline(
          [{ timeline, channel: 'steam' }],
          timeline_of_start_time,
          timeline_of_end_time,
        );
        setTrendsTimeline(localTrendsTimeline.steam);
        const { steam, ...otherInfo } = gameStoreMap || {};

        setBottomGameStore(otherInfo);
        setSteamInfo(arrayToObj(steam, 'key'));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const renderList = useMemo(() => {
    const keys = Object.keys(bottomGameStore);
    const infoList = keys.reduce((pre: Array<any>, key: string) => {
      const list = bottomGameStore[key];
      const obj = dealwithOpencritic(list, key, channelMapItem[key]);
      if (obj.review === 0 && obj.score === 0) return pre;
      return [...pre, obj];
    }, []);

    const sortItems = Object.keys(channelMapItem);
    infoList.sort(
      (a, b) => sortItems.indexOf(a.channel) - sortItems.indexOf(b.channel),
    );

    return infoList;
  }, [bottomGameStore]);

  useEffect(() => {
    if (filter.edition_unified_id) {
      requestServerData();
    }
  }, [filter]);

  return {
    trendTimeline,
    steamInfo,
    bottomGameStore,
    loading,
    bottomGameStoreRenderList: renderList,
  };
}
